export * from "./IHisInfoSelectDialog";
export { default as HisInfoSelectDialog } from "./HisInfoSelectDialog.vue";
